export const _LAYOUT_NAME = {
	NONE_LAYOUT: 'NoneLayout',
	DEFAULT_LAYOUT: 'DefaultLayout',
	AUTH_LAYOUT: 'AuthLayout',
};
